module.exports = __webpack_public_path__ + "img/B3-5.ec0ad44e.jpg";